import apiRequest from './client';

const toQuery = (params) => {
  const qs = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
  return qs ? `?${qs}` : '';
};

// tirage = code loterie (optionnel, '0'/vide = toutes), no = Ticket.no (N° de
// fiche propre a la loterie, optionnel) — ciblage plus fin en plus de sq.
export const searchRevertTickets = ({ bank, sq, searchBy, date, tirage, no }) =>
  apiRequest(`/tickets/revert/search/${toQuery({ bank, sq, search_by: searchBy, date, tirage, no })}`);

export const revertTicket = (ticketId) =>
  apiRequest(`/tickets/revert/${ticketId}/`, { method: 'POST' });
